jQuery(document).ready(function ($) {
    $('.footer__mobile--item.toggle').on('click', function (event) {
        event.preventDefault();

        $(this).toggleClass('expanded');
        $(this).next().slideToggle(500);
    });
});